<template>
  <div>
    <quill-editor
      v-model="content"
      ref="myQuillEditor"
      :options="editorOption"
      style="height: 20rem;"
    ></quill-editor>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  props: {
    description: String
  },
  components: {
    quillEditor
  },
  data() {
    return {
      content: this.description,
      editorOption: {
        placeholder: "Enter description ...",
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ align: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ color: [] }, { background: [] }],
          ]
        }
      }
    };
  },
  watch: {
    content: function(latestContent) {
      this.$emit("updateContent", latestContent);
    },
    description: function(latest) {
      this.content = latest;
      console.log(latest);
    }
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
};
</script>

<style scoped>
</style>